// react
import React, { Component } from 'react';

// third-party
import PropTypes from 'prop-types';

// application
//import products from '../../data/shopProducts';
import { connect } from 'react-redux'

import {Link} from 'react-router-dom';
import { toast } from 'react-toastify';

// data stubs
import BlockProductsCarousel from './BlockProductsCarousel';

import { getProductsKeyBased } from '../../store/products';
import { getKeyBasedProducts } from '../../services';

import products from '../../data/shopProducts';

class BlockTabbedProducts extends Component {
    timeout;

    constructor(props) {
        super(props);

        this.state = {
            products: [],
            loading: false
            // groups: [
            //     { id: 1, name: 'All', current: true },
            //     { id: 2, name: 'Power Tools', current: false },
            //     { id: 3, name: 'Hand Tools', current: false },
            //     { id: 4, name: 'Plumbing', current: false },
            // ],
        };
    }

    componentWillUnmount() {
        clearTimeout(this.timeout);
    }

    componentDidMount() {
        if(!this.props.products.length){
            this.props.dispatch(getProductsKeyBased(this.props.searchBy,this.props.keyparam)).then(response => {
                this.setState((state) => (
                    {
                        products : response
                    }
                ));
            }).catch(err => {
               // toast.error("Login Failed. Please enter valid credentials");
            });
        }
        else
        {
            this.setState((state) => (
                {
                    products : this.props.products
                }
            ));
        }
    }

    handleChangeGroup = (newCurrentGroup) => {
        clearTimeout(this.timeout);

        const { groups } = this.state;
        const currentGroup = groups.find((group) => group.current);

        if (currentGroup && currentGroup.id === newCurrentGroup.id) {
            return;
        }

        this.setState((state) => (
            {
                loading: true,
                groups: state.groups.map((group) => (
                    { ...group, current: group.id === newCurrentGroup.id }
                )),
            }
        ));

        // sending request to server, timeout is used as a stub
        this.timeout = setTimeout(() => {
            this.setState((state) => {
                // this is only for demo purpose
                const itemsArray = state.products.slice();
                const newItemsArray = [];
                while (itemsArray.length > 0) {
                    const randomIndex = Math.floor(Math.random() * itemsArray.length);
                    const randomItem = itemsArray.splice(randomIndex, 1)[0];
                    newItemsArray.push(randomItem);
                }

                return {
                    products: newItemsArray,
                    loading: false,
                };
            });
        }, 2000);
    };

    render() {
        return (
            <BlockProductsCarousel
                {...this.props}
                {...this.state}
                onGroupClick={this.handleChangeGroup}
            />
        );
    }
}


const mapStateToProps = (state, ownProps) => ({
    products: getKeyBasedProducts(state.products,ownProps.searchBy,ownProps.keyparam)
})

export default connect(
    mapStateToProps
)(BlockTabbedProducts)

BlockTabbedProducts.propTypes = {
    title: PropTypes.string.isRequired,
    layout: PropTypes.oneOf(['grid-4', 'grid-4-sm', 'grid-5', 'horizontal']),
    rows: PropTypes.number,
    withSidebar: PropTypes.bool,
};

BlockTabbedProducts.defaultProps = {
    layout: 'grid-4',
    rows: 1,
    withSidebar: false,
};
